module.exports = __webpack_public_path__ + "c0d87bd265390444ada7ca08e26a2d27.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/sites/walk/favicon.ico
// module id = 1853
// module chunks = 1